import AuthLayout from "../pages/Dashboard/Pages/AuthLayout.vue";
import Login from "../pages/Dashboard/Pages/Login.vue";

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login
        },
    ]
};

const routes = [
    {
        path: "*",
        redirect: "/login",
        name: "Login"
    },
    {
        path: "/",
        redirect: "/login",
        name: "Login"
    },
    authPages
];

export default routes;
